// ─── Date utility functions ───────────────────────────────────────────────────

export const todayStr = () => new Date().toISOString().split("T")[0];

export const parseDate = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const dispDate = (s) =>
  parseDate(s).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

export const nextDay = (s) => {
  const d = new Date(s);
  d.setDate(d.getDate() + 1);
  return d.toISOString().split("T")[0];
};

export const daysBetween = (a, b) =>
  Math.round((parseDate(b) - parseDate(a)) / 86400000);

export const addDays = (s, n) => {
  const d = new Date(s);
  d.setDate(d.getDate() + n);
  return d.toISOString().split("T")[0];
};
